import ContentLoader from 'react-content-loader';
import {
  Table,
  TABLE_SIZES,
  TABLE_SORT_DIRECTIONS,
} from '@reverse-hr/design-system';
import { CUSTOMER_APPLICATIONS_ORDER } from '@app/constants/applications';

const SORT_DIRECTIONS_MAP = {
  [CUSTOMER_APPLICATIONS_ORDER.ASC]: TABLE_SORT_DIRECTIONS.ASCENDING,
  [CUSTOMER_APPLICATIONS_ORDER.DESC]: TABLE_SORT_DIRECTIONS.DESCENDING,
};

const LOADER_HEADER_HEIGHT = 44;
const LOADER_ROW_HEIGHT = 60;
const LOADER_ROW_COUNT = 6;

export const CustomerApplicationsTable = ({
  className,
  columns,
  emptyContent,
  isLoading,
  onColumnHeaderClick,
  rows,
  sortBy,
  sortDirection,
}) => {
  const isEmptyContentVisible = rows.length === 0 && !!emptyContent;

  if (isLoading) {
    return (
      <div className={className}>
        <ContentLoader
          height={LOADER_HEADER_HEIGHT}
          style={{ width: '100%' }}
          title=""
        >
          <rect
            height={LOADER_HEADER_HEIGHT}
            style={{ width: '100%' }}
            x="0"
            y="0"
          />
        </ContentLoader>

        <ContentLoader
          height={LOADER_ROW_HEIGHT * LOADER_ROW_COUNT}
          style={{ width: '100%' }}
          title=""
        >
          {Array.from({ length: LOADER_ROW_COUNT }, (_, index) => (
            <rect
              height={LOADER_ROW_HEIGHT - 5}
              key={index}
              style={{ width: '100%' }}
              x="0"
              y={index * LOADER_ROW_HEIGHT}
            />
          ))}
        </ContentLoader>
      </div>
    );
  }

  return (
    <>
      <Table className={className} isStriped size={TABLE_SIZES.SMALL}>
        <Table.Header>
          <Table.Row>
            {columns.map(column => (
              <Table.HeaderCell
                isSortable={column.isSortable}
                key={column.name}
                onSort={() => onColumnHeaderClick(column.name)}
                sortDirection={
                  sortBy === column.name
                    ? SORT_DIRECTIONS_MAP[sortDirection]
                    : null
                }
              >
                {column.content}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {rows.map((row, rowIndex) => (
            <Table.Row key={rowIndex}>
              {columns.map(column => {
                const cell = row[column.name];

                return (
                  <Table.Cell key={column.name}>
                    {cell?.url ? (
                      <a href={cell.url}>{cell.content}</a>
                    ) : (
                      cell?.content
                    )}
                  </Table.Cell>
                );
              })}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      {isEmptyContentVisible && (
        <p className="c-customer-applications__empty">{emptyContent}</p>
      )}
    </>
  );
};
